export default "__VITE_ASSET__w3BPbZlc__"